<template>
<div class="tooltip left">
    <span class="tiptext">{{status}} - {{building}} {{ehs_name ? '- '+ehs_name:''}}</span>
    <span class="material-icons sm" :style="{color:color}">{{icon}}</span>
</div>
    
</template>

<script>
export default {
  props:['color', 'icon', 'status', 'ehs_name','building']
}
</script>

<style lang="stylus">
 
</style>